import axios from "axios";
import { endpoints } from "../_config";

class DashboardService {
  /**
   * Get super admin dashboard count
   * @param {*} Bearer token
   * @returns
   */
  static async getDashboardData(user) {
    return axios
      .get(endpoints.dashboard.all, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get organisation admin dashboard count
   * @param {*} Bearer token
   * @returns
   */
  static async getOrgAdminDashboardData(user) {
    return axios
      .get(endpoints.dashboard.orgAdmin, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { DashboardService };
